(() => {
  'use strict';

  const config = document.querySelector('[data-tiavola-analytics]');
  const measurementId = config?.dataset.measurementId?.trim();
  if (!/^G-[A-Z0-9]+$/.test(measurementId || '') || window.Shopify?.designMode) return;
  const preview = config.dataset.preview === 'true';
  if (preview && config.dataset.debug !== 'true') return;

  const storageKey = 'tiavola:pending-enquiry:v1';
  const services = new Set(['build_redesign', 'migration', 'custom_development', 'ongoing_optimisation', 'app_support', 'other']);
  const pageLanguage = document.documentElement?.lang === 'ar' ? 'ar' : 'en';
  const safeService = (value) => services.has(value) ? value : 'other';
  const disableKey = `ga-disable-${measurementId}`;
  const bookedFrames = new WeakSet();
  let initialized = false;
  let allowed = false;

  function cleanUrl(value, campaigns = false) {
    try {
      const source = new URL(value);
      const clean = new URL(source.origin + source.pathname);
      if (campaigns) {
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach((key) => {
          const value = source.searchParams.get(key);
          if (value && /^[a-z0-9_. -]{1,100}$/i.test(value)) clean.searchParams.set(key, value);
        });
      }
      return clean.href;
    } catch {
      return '';
    }
  }

  function consentAllowed() {
    return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  }

  function clearPending() {
    try { window.sessionStorage.removeItem(storageKey); } catch {  }
  }

  function send(name, parameters = {}) {
    if (!initialized || !allowed || !consentAllowed()) return false;
    window.gtag('event', name, {
      send_to: measurementId,
      page_location: cleanUrl(window.location.href, true),
      page_referrer: cleanUrl(document.referrer),
      page_path: window.location.pathname,
      page_language: pageLanguage,
      ...parameters,
      ...(preview ? { debug_mode: true, traffic_type: 'developer' } : {})
    });
    return true;
  }

  function trackConfirmedEnquiry() {
    const success = document.querySelector('[data-tiavola-enquiry-success]');
    const form = success?.closest('form[data-tiavola-enquiry-form]');
    if (!form) return;
    let pending;
    try { pending = JSON.parse(window.sessionStorage.getItem(storageKey)); } catch { return; }
    if (!pending || pending.formId !== form.id || pending.path !== window.location.pathname) return;
    clearPending();
    const age = Date.now() - pending.at;
    if (age < 0 || age > 30 * 60 * 1000) return;
    send('generate_lead', { form_id: form.id, lead_method: 'contact_form', service_interest: safeService(pending.service) });
  }

  function syncConsent() {
    allowed = consentAllowed();
    window[disableKey] = !allowed;
    if (!allowed) {
      clearPending();
      if (initialized) window.gtag('consent', 'update', { analytics_storage: 'denied' });
      return;
    }
    if (!initialized) {
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
      window.gtag('consent', 'default', {
        analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied'
      });
      window.gtag('consent', 'update', { analytics_storage: 'granted' });
      window.gtag('js', new Date());
      window.gtag('config', measurementId, {
        send_page_view: false,
        allow_google_signals: false,
        allow_ad_personalization_signals: false,
        page_location: cleanUrl(window.location.href, true),
        page_referrer: cleanUrl(document.referrer)
      });
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      script.async = true;
      document.head.appendChild(script);
      initialized = true;
      send('page_view');
    } else {
      window.gtag('consent', 'update', { analytics_storage: 'granted' });
    }
    trackConfirmedEnquiry();
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches?.('form[data-tiavola-enquiry-form]') || !form.checkValidity() || !allowed || !consentAllowed()) return;
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify({ formId: form.id, path: window.location.pathname, service: safeService(form.querySelector?.('[data-tiavola-service]')?.value), at: Date.now() }));
    } catch {  }
  }, true);

  document.addEventListener('click', (event) => {
    const booking = event.target.closest?.('[data-tiavola-booking-click]');
    if (booking) send('book_call_click', { link_placement: booking.dataset.tiavolaBookingClick });
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    try {
      const url = new URL(link.href);
      if (url.hostname === 'apps.shopify.com' && url.pathname === '/codswitch-cod-fees-rules') {
        send('app_store_click', { app_name: 'CODSwitch', link_domain: 'apps.shopify.com' });
      }
    } catch {  }
  });

  window.addEventListener('message', (event) => {
    if (event.origin !== 'https://calendly.com' || event.data?.event !== 'calendly.event_scheduled') return;
    const frame = Array.from(document.querySelectorAll('.calendly-inline-widget iframe')).find((iframe) => {
      try { return iframe.contentWindow === event.source && new URL(iframe.src).origin === event.origin; } catch { return false; }
    });
    if (!frame || bookedFrames.has(frame)) return;
    bookedFrames.add(frame);
    send('meeting_booked', { lead_method: 'calendly_embed' });
  });

  document.addEventListener('visitorConsentCollected', syncConsent);
  if (window.Shopify?.customerPrivacy) {
    syncConsent();
  } else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
      if (!error) syncConsent();
    });
  }
})();
